import RadioButtonUI from "@UI/RadioButtonUI";
import { inject, observer } from "mobx-react";
import { Card } from "primereact/card";
import { Chip } from "primereact/chip";
import { InputTextarea } from "primereact/inputtextarea";
import { Sidebar } from "primereact/sidebar";
import { useEffect, useState } from "react";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";
import InputTextareaUI from "@UI/InputTextareaUI";
import { toJS } from "mobx";

// === Константы ===
const SCENARIO_INCLUSION = "inclusion";
const SCENARIO_EXCLUDED = "excluded";

const CHANGE_DATA = [
    { label: "Показывать оффер для выбранной географии", value: true },
    { label: "Не показывать оффер для выбранной географии", value: false },
];

const NAMES_MAP = {
    cities: "город",
    regions: "регион",
    metro: "метро",
};

// === Вспомогательные функции ===

/**
 * Извлекает ключи geoObject по уровням:
 * - regionIds: все ключи первого уровня
 * - cityIds: все ключи второго уровня
 * - metroStationIds: все ключи третьего уровня
 */
function extractGeoArrays(geoObject = {}) {
    const regionIds = [];
    const cityIds = [];
    const metroStationIds = [];

    for (const regionId in geoObject) {
        if (!Object.hasOwn(geoObject, regionId)) continue;
        regionIds.push(regionId);

        const regionContent = geoObject[regionId];

        // Обработка городов
        if (regionContent.cities && typeof regionContent.cities === "object") {
            for (const cityId in regionContent.cities) {
                if (Object.hasOwn(regionContent.cities, cityId)) {
                    cityIds.push(cityId);
                }

                const cityContent = regionContent.cities[cityId];

                if (cityContent?.metroStations && typeof cityContent?.metroStations === "object") {
                    for (const metroId in cityContent.metroStations) {
                        if (Object.hasOwn(cityContent.metroStations, metroId)) {
                            metroStationIds.push(metroId);
                        }
                    }
                }
            }
        }

        // Обработка станций метро
        if (regionContent.metroStations && typeof regionContent.metroStations === "object") {
            for (const metroId in regionContent.metroStations) {
                if (Object.hasOwn(regionContent.metroStations, metroId)) {
                    metroStationIds.push(metroId);
                }
            }
        }
    }

    return { regionIds, cityIds, metroStationIds };
}

/**
 * Преобразует массивы ID в объекты через словарь
 */
function getByIds(ids = [], dict = {}) {
    const seen = new Set();
    return ids.reduce((acc, id) => {
        if (seen.has(id)) return acc;
        seen.add(id);
        const item = dict[id];
        if (item) acc.push(item);
        return acc;
    }, []);
}

// === Основной компонент ===
const CompaniesGeo = inject("mainStore")(
    observer(({ mainStore, disabled }) => {
        // === Store данные ===
        const regionAll = mainStore.getMainStore("modified.regionIds_suggest");
        const citiesAll = mainStore.getMainStore("modified.cityIds_suggest");
        const metroAll = mainStore.getMainStore("modified.metrostationsIds_suggest");
        const detailData = mainStore.getMainStore("detailData");
        const filial = mainStore.getMainStore("filial");

        const [countSearchName, setCountSearchName] = useState(0);
        const [visible, setVisible] = useState(false);
        const [data, setData] = useState(null);
        const [valueGeo, setValueGeo] = useState("");
        const [radio, setRadio] = useState(true);

        const { regionIds, cityIds, metroStationIds } = extractGeoArrays(detailData?.geoObject);

        const regionCompanies = getByIds(regionIds, regionAll);
        const citiesCompanies = getByIds(cityIds, citiesAll);
        const metroCompanies = getByIds(metroStationIds, metroAll);

        const cityRegionSet = new Set(data?.cities?.map((c) => c.region?._id));

        useEffect(() => {
            if (detailData?.addressId) {
                getFilial();
            }
        }, [detailData?.addressId]);

        useEffect(() => {
            if (!visible) {
                setValueGeo("");
            }
        }, [visible]);

        const getFilial = async () => {
            await mainStore.getByUrl(`promo/offeraddresses/${detailData.addressId}`, false, "filial");
        };

        const handleClickAddButton = async () => {
            const lines = valueGeo
                .split(/[\n,]+/)
                .map((s) => s.trim())
                .filter(Boolean);

            if (lines.length === 0) return;

            setCountSearchName(lines.length);

            const scenario = radio ? SCENARIO_INCLUSION : SCENARIO_EXCLUDED;

            const resp = await mainStore.postByUrl("supply/suggest_from_list", { words: lines, scenario }, "", false, true);

            if (resp?.success) {
                const { regionIds, cityIds, metroStationIds } = extractGeoArrays(resp?.data?.geoObject);

                const regionCompanies = getByIds(regionIds, regionAll);
                const citiesCompanies = getByIds(cityIds, citiesAll);
                const metroCompanies = getByIds(metroStationIds, metroAll);
                console.log(toJS(metroAll));
                setData({ ...resp?.data, regions: regionCompanies, cities: citiesCompanies, metro: metroCompanies, geoObject: resp?.data?.geoObject });
            }
        };

        const handleClick = () => {
            if (!data) return;

            // Если есть совпадения и не найденные — покажем только их

            let result = {};

            if (detailData?.geoObject && Object.values(detailData?.geoObject).length) {
                for (const key in detailData.geoObject) {
                    // Проверяем, есть ли такой же ключ во втором объекте
                    if (Object.hasOwn(data.geoObject, key)) {
                        const regionContent = data.geoObject[key];

                        if (regionContent.cities && typeof regionContent.cities === "object") {
                            for (const cityId in regionContent.cities) {
                                if (Object.hasOwn(regionContent.cities, cityId)) {
                                    result[key] = { ...detailData.geoObject[key], cities: { ...detailData.geoObject[key].cities, ...data.geoObject[key].cities } };
                                }
                            }
                        }

                        if (regionContent.metroStations && typeof regionContent.metroStations === "object") {
                            for (const cityId in regionContent.metroStations) {
                                if (Object.hasOwn(regionContent.metroStations, cityId)) {
                                    result[key] = { ...detailData.geoObject[key], metroStations: { ...detailData.geoObject[key].metroStations, ...data.geoObject[key].metroStations } };
                                }
                            }
                        }
                    } else {
                        result = { ...detailData.geoObject, ...data.geoObject, ...result };
                    }
                }
            } else {
                result = { ...detailData.geoObject, ...data.geoObject };
            }

            mainStore.setMainStore("detailData", {
                ...detailData,
                geoObject: result,
            });

            if (data.coincidencesArray?.length && data.notFound?.length) {
                setData({
                    coincidencesArray: data.coincidencesArray,
                    notFound: data.notFound,
                });
                setValueGeo("");
                return;
            }

            setVisible(false);
        };

        const handleDeleteSidebar = (type, id) => {
            if (!data || !data[type]) return;

            const updatedList = data[type].filter((item) => item._id !== id);
            const newData = { ...data, [type]: updatedList };

            // Удаляем элемент из geoObject
            const newGeoObject = { ...data.geoObject };

            if (type === "regions") {
                // Удаляем регион из geoObject
                delete newGeoObject[id];
            } else if (type === "cities") {
                // Удаляем город из всех регионов в geoObject
                for (const regionId in newGeoObject) {
                    if (newGeoObject[regionId]?.cities?.[id] !== undefined) {
                        if (Object.values(newGeoObject[regionId].cities).length > 1) {
                            delete newGeoObject[regionId]?.cities[id];
                        } else {
                            delete newGeoObject[regionId];
                        }

                        break;
                    }
                }
            } else if (type === "metro") {
                // Удаляем станцию метро из всех регионов в geoObject
                for (const regionId in newGeoObject) {
                    if (newGeoObject[regionId]?.metroStations?.[id]) {
                        delete newGeoObject[regionId].metroStations[id];
                        // Если больше нет станций метро в регионе, удаляем регион
                        if (Object.keys(newGeoObject[regionId].metroStations).length === 0) {
                            delete newGeoObject[regionId];
                        }
                        break;
                    }
                }
            }

            const { regionIds, cityIds, metroStationIds } = extractGeoArrays(newGeoObject);

            const regionCompanies = getByIds(regionIds, regionAll);
            const citiesCompanies = getByIds(cityIds, citiesAll);
            const metroCompanies = getByIds(metroStationIds, metroAll);

            // Обновляем данные с новым geoObject
            newData.geoObject = newGeoObject;
            newData.regions = regionCompanies;
            newData.cities = citiesCompanies;
            newData.metro = metroCompanies;

            // newData.geoObject = newGeoObject;

            const isEmpty = !Object.keys(newData.geoObject).length;

            if (isEmpty) {
                setData(null);
                setValueGeo("");
            } else {
                setData(newData);
            }
        };

        const removeFilial = async (cities) => {
            if (!filial?._id || !filial.addresses) return;

            const allowedCities = new Set(cities.map((item) => item.city));
            const filteredAddresses = filial.addresses.filter((addr) => allowedCities.has(addr.city));

            await mainStore.putByUrl(`promo/offeraddresses/${filial._id}`, {
                ...filial,
                addresses: filteredAddresses,
            });
        };

        const handleDeleteElement = async (itemId, keyStore) => {
            const newGeoObject = toJS(detailData?.geoObject || {});

            if (keyStore === "regionIds") {
                delete newGeoObject[itemId];
            } else if (keyStore === "cityIds") {
                for (const regionId in newGeoObject) {
                    if (newGeoObject[regionId]?.cities?.[itemId] !== undefined) {
                        if (Object.values(newGeoObject[regionId].cities).length > 1) {
                            delete newGeoObject[regionId]?.cities[itemId];
                        } else {
                            delete newGeoObject[regionId];
                        }

                        break;
                    }
                }
            } else if (keyStore === "metroStationIds") {
                for (const regionId in newGeoObject) {
                    if (newGeoObject[regionId]?.metroStations?.[itemId] !== undefined) {
                        if (Object.values(newGeoObject[regionId].metroStations).length > 1) {
                            delete newGeoObject[regionId]?.metroStations?.[itemId];
                        } else {
                            delete newGeoObject[regionId];
                        }

                        break;
                    }
                }
            }

            mainStore.setMainStore("detailData", {
                ...detailData,
                geoObject: newGeoObject,
            });

            if (keyStore === "cityIds") {
                const updatedCities = citiesCompanies.filter((c) => c._id !== itemId);
                await removeFilial(updatedCities);
            }
        };

        const handleDeleteAll = () => {
            mainStore.setMainStore("detailData", {
                ...detailData,
                geoObject: {},
            });
        };

        const hasGeo = data?.regions?.length || data?.cities?.length || data?.metro?.length;

        return (
            <div className="geo__block">
                <Sidebar visible={visible} position="right" blockScroll onHide={() => setVisible(false)}>
                    <Card title="Добавление географии" className="content">
                        {!hasGeo ? (
                            <div className="wrapper">
                                <RadioButtonUI radioData={CHANGE_DATA} onChange={(e) => setRadio(e.value)} value={radio} />
                                <InputTextareaUI autoResize value={valueGeo} onChange={(e) => setValueGeo(e.target.value)} rows={5} cols={30} placeholder="Введите данные, которые относятся к географии оффера (регионы, города, станции метро)" />
                                <ButtonUI label="Добавить" onClick={handleClickAddButton} severity="success" style={{ maxWidth: "140px" }} disabled={!valueGeo.trim()} />
                                {data?.notFound?.length ? (
                                    <div className="block__select error">
                                        <div className="title">
                                            <i className="pi pi-exclamation-triangle" />
                                            Ошибка
                                        </div>
                                        <div className="item__list">
                                            {data.notFound.map((item, idx) => (
                                                <Chip key={idx} label={item} />
                                            ))}
                                        </div>
                                    </div>
                                ) : null}
                                {data?.coincidencesArray?.length ? (
                                    <div className="block__select coincidence">
                                        <i className="pi pi-exclamation-circle" />
                                        <div>
                                            <span className="title">Возможно вы хотели добавить:</span>
                                            <br />
                                            {data.coincidencesArray.map((i) => `${NAMES_MAP[i.type]} ${i.out}`).join(", ")}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div className="wrapper">
                                <div className="header__text">
                                    {`Добавлено ${countSearchName - (data.notFound?.length || 0)} из ${countSearchName}`}
                                    {data.notFound?.length ? <span>{` (${data.notFound.length} не найдено)`}</span> : null}
                                </div>

                                {data.regions?.length ? (
                                    <div className="block__select">
                                        <span className="title">Регионы</span>
                                        <div className="item__list">
                                            {data.regions.map((item) => {
                                                const highlight = !cityRegionSet.has(item._id);

                                                return (
                                                    <div className={`chip__item ${highlight ? "chip__item_highlight" : ""}`} key={item._id}>
                                                        <span>{item.name_with_type}</span>
                                                        <i className="pi pi-times-circle" onClick={() => handleDeleteSidebar("regions", item._id)} />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : null}

                                {data.cities?.length ? (
                                    <div className="block__select">
                                        <span className="title">Города</span>
                                        <div className="item__list">
                                            {data.cities.map((item) => (
                                                <div className="chip__item" key={item._id}>
                                                    <span>
                                                        {item.city}
                                                        {item.region?.name_with_type ? ` (${item.region.name_with_type})` : ""}
                                                    </span>
                                                    <i className="pi pi-times-circle" onClick={() => handleDeleteSidebar("cities", item._id)} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : null}

                                {data.metro?.length ? (
                                    <div className="block__select">
                                        <span className="title">Станции метро2</span>
                                        <div className="item__list">
                                            {data.metro.map((item) => {

                                                const parentName = item.parentType === "city" ? citiesAll[item.parentId]?.city : regionAll[item.parentId]?.name_with_type || "";

                                                return (
                                                    <div className="chip__item" key={item._id}>
                                                        <span>
                                                            {item.name}
                                                            {` (${parentName})`}
                                                        </span>
                                                        <i className="pi pi-times-circle" onClick={() => handleDeleteSidebar("metro", item._id)} />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : null}

                                {data.notFound?.length ? (
                                    <div className="block__select error">
                                        <div className="title">
                                            <i className="pi pi-exclamation-triangle" />
                                            Ошибка
                                        </div>
                                        <div className="item__list">
                                            {data.notFound.map((item, idx) => (
                                                <Chip key={idx} label={item} />
                                            ))}
                                        </div>
                                    </div>
                                ) : null}

                                <ButtonUI label="Добавить" onClick={handleClick} severity="success" style={{ maxWidth: "140px" }} />
                            </div>
                        )}
                    </Card>
                </Sidebar>

                {/* Отображение текущих значений */}
                <div className="component">
                    <label>Регионы</label>
                    <div className="input__block">
                        {regionCompanies.length ? (
                            regionCompanies.map((item) => {
                                const highlight = !Object.values(detailData.geoObject[item._id]).length;

                                return (
                                    <div className={`chip__item ${highlight ? "chip__item_highlight" : ""}`} key={item._id}>
                                        <span>{item.name_with_type}</span>
                                        <i className="pi pi-times-circle" onClick={() => handleDeleteElement(item._id, "regionIds")} />
                                    </div>
                                );
                            })
                        ) : (
                            <span className="placeholder">Появится после добавления регионов</span>
                        )}
                    </div>
                </div>

                <div className="component">
                    <label>Города</label>
                    <div className="input__block">
                        {citiesCompanies.length ? (
                            citiesCompanies.map((item) => (
                                <div className="chip__item" key={item._id}>
                                    <span>{item.city}</span>
                                    <i className="pi pi-times-circle" onClick={() => handleDeleteElement(item._id, "cityIds")} />
                                </div>
                            ))
                        ) : (
                            <span className="placeholder">Появится после добавления городов</span>
                        )}
                    </div>
                </div>

                <div className="component">
                    <label>Станции метро</label>
                    <div className="input__block">
                        {metroCompanies.length ? (
                            metroCompanies.map((item) => {
                                const regionName = regionAll[item.parentId]?.name_with_type;
                                const cityName = citiesAll[item.parentId]?.city;
                                const parenName = regionName || cityName || "";

                                return (
                                    <div className="chip__item" key={item._id}>
                                        <span>
                                            {item.name}
                                            {parenName ? ` (${parenName})` : ""}
                                        </span>
                                        <i className="pi pi-times-circle" onClick={() => handleDeleteElement(item._id, "metroStationIds")} />
                                    </div>
                                );
                            })
                        ) : (
                            <span className="placeholder">Появится после добавления станций метро</span>
                        )}
                    </div>
                </div>

                <div className="row">
                    <ButtonUI
                        className="button__rate"
                        label="Добавить ГЕО"
                        icon="pi pi-plus-circle"
                        outlined
                        disabled={disabled}
                        onClick={() => {
                            setVisible(true);
                            setData(null);
                        }}
                        style={{ width: "100%" }}
                    />
                    {detailData?.geoObject && Object.keys(detailData?.geoObject).length ? (
                        <ButtonUI className="button__rate" severity="danger" label="Удалить все" icon="pi pi-trash" outlined onClick={handleDeleteAll} style={{ width: "100%" }} />
                    ) : null}
                </div>
            </div>
        );
    }),
);

export default CompaniesGeo;
